export const DEFAULT_RESPONSE_COUNT = 20;

export const ENTITIES = {
  earnings: 'earnings',
  payouts: 'payouts',
};

export const FILTERS = {
  all: 'all',
  lastWeek: 'last_week',
  lastMonth: 'last_month',
  lastThreeMonths: 'last_three_months',
};

export const JAVA_FILTERS = {
  all: 'all',
  lastWeek: 'last-week',
  lastMonth: 'last-month',
  lastThreeMonths: 'last-three-months',
};

export const OPTIONS = [
  { value: FILTERS.all, label: 'app:allTime' },
  { value: FILTERS.lastWeek, label: 'app:lastWeek' },
  { value: FILTERS.lastMonth, label: 'app:lastMonth' },
  { value: FILTERS.lastThreeMonths, label: 'app:lastThreeMonths' },
];

export const JAVA_OPTIONS = [
  { value: JAVA_FILTERS.all, label: 'app:allTime' },
  { value: JAVA_FILTERS.lastWeek, label: 'app:lastWeek' },
  { value: JAVA_FILTERS.lastMonth, label: 'app:lastMonth' },
  { value: JAVA_FILTERS.lastThreeMonths, label: 'app:lastThreeMonths' },
];

export const TRANSACTION_TYPES = {
  cashback: 'Plus::Cashback',
  bonus: 'Plus::Bonus',
  karmaCash: 'Plus::KarmaCash',
  karmaPayRedemption: 'Plus::Redemption',
  game: 'Plus::Games',
  karmaPayCompensation: 'Plus::KarmaPayCompensation',
  surpriseBox: 'Plus::SurpriseBox',
};

export const TRANSACTION_KINDS = {
  admin: 'admin',
  earn_demographic_data: 'earn_demographic_data',
  earn_game_install: 'earn_game_install',
  earn_game_milestone: 'earn_game_milestone',
  earn_games: 'earn_games',
  earn_offers: 'earn_offers',
  earn_scans: 'earn_scans',
  earn_surveys: 'earn_surveys',
  earn_videos: 'earn_videos',
  extension_installation: 'extension_installation',
  failed_coupons: 'failed_coupons',
  purchase: 'purchase',
  refund: 'refund',
  streak_rewards: 'streak_rewards',
  swe: 'swe',
  welcome: 'welcome',
  surprise_box_coins: 'surprise_box_coins',
  surprise_box_ticket: 'surprise_box_ticket',
};

export const TRANSACTION_STATUSES = {
  pending: 'pending',
  pendingKarmaEarn: 'pendingKarmaEarn', // custom status
  confirmed: 'confirmed',
  cancelled: 'cancelled',
  invalid: 'invalid',
  paused: 'paused',
  paid: 'paid',
  empty: 'empty',
  expired: 'expired',
  completed: 'completed',
  notQualified: 'not-qualified',
};

export const WITHDRAWAL_BLOCK_REASONS = {
  reach_cap: 'reach_cap',
  below_threshold: 'below_threshold',
  threshold_review: 'threshold_review',
  in_review: 'in_review',
  block_withdrawal: 'block_withdrawal',
};
